var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"message-header"},[_c('i',{staticClass:"r2-icon-hardware_keyboard_backspace_outlined margin-right-5 cursor-pointer",on:{"click":_vm.handleClick}}),_vm._v(" "+_vm._s(_vm.pageTitle)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }